import React from 'react'

export const BannerInclusion = () => {
    return (
		<div className="container">
		<div className="sixteen columns">
			<h3 className="headline centered">
				<span style={{ fontSize: 'xx-large' }}><i className="ln   ln-icon-Wheelchair" style={{ fontSize: 'xx-large' }}></i></span><br></br>
				Programa de Inclusión
				<span style={{ fontSize: 'x-large' }} className="margin-top-25">La diversidad forma parte de la cultura de XinerLink. Sabemos por experiencia que una discapacidad, preferencia sexual o nacionalidad no están asociados a un mejor o peor desempeño laboral. Desde el año 2017 tenemos un programa especial de Inclusión y Diversidad. Trabajamos para ser un referente en la industria de RRHH. Nuestra experiencia, trabajo y asesoría están a disposición de nuestros clientes.</span>
				<a  style={{ fontSize: 'medium' }} target='_blank' rel="noopener noreferrer" href='https://www.xinerlink.cl/programa-de-Inclusion/'><i className="ln ln-icon-Film-Board" ></i> Vea nuestros videos.</a>
			</h3>
		</div>
		</div>
    )
}